<template>
  <!-- D: 모달은 .l-wrap 바깥에 넣어주세요.
  - 퍼블에서는 hidden 클래스넣지만 개발에서는 동적으로 불러와야할 듯합니다
  - 해당 팝업은 MO에서는 풀로 나오는 형태라 type-mo-full 클래스 추가해주셔야합니다.
-->
  <AbstractPop :type-mo-full="true" :only-mo="true">
    <template v-slot>
      <div class="dialog type-filter">
        <header class="dialog-header">
          <h2>
            <span class="sr-only">필터설정 팝업</span>
          </h2>
          <button
            type="button"
            class="dialog-close"
            @click="() => emits('close')"
          >
            <span class="c-icon icon-large-x"></span>
            <span class="sr-only">팝업 닫기</span>
          </button>
        </header>

        <div class="dialog-content">
          <div class="dialog-content-inner">
            <!-- D: MO에서만 존재 -->
            <h3 class="c-title-level3 only-mo">필터설정</h3>

            <div class="m-filter-wrap">
              <MobileFilterPopRow
                v-if="lvl2Categories"
                :category-name="'시장'"
                v-model:categories="lvl2Categories"
                @select-changed="changeMoProd('1')"
              />
              <MobileFilterPopRow
                v-if="lvl3Categories"
                :category-name="'용도'"
                v-model:categories="lvl3Categories"
                @select-changed="changeMoProd('2')"
              />
              <MobileFilterPopRow
                v-if="lvl4Categories"
                :category-name="'제품군'"
                v-model:categories="lvl4Categories"
              />
              <!-- <MobileFilterPopRow
                v-if="lvl3Categories"
                :category-name="'용도'"
                v-model:categories="lvl3Categories"
              />
              <MobileFilterPopRow
                v-if="lvl4Categories"
                :category-name="'제품군'"
                v-model:categories="lvl4Categories"
              />
              <MobileFilterPopRow
                v-if="lvl4Categories"
                :category-name="'제품규격'"
                v-model:categories="totalQtyCategories"
              />
              <MobileFilterPopRow
                v-if="lvl4Categories"
                :category-name="'SET/개별제품'"
                v-model:categories="setgdYnCategories"
              /> -->
            </div>
          </div>
        </div>

        <!-- D: MO에서만 노출 -->
        <div class="dialog-footer only-mo">
          <!-- D: 필터 선택 -->
          <div class="c-option-choice">
            <div class="choice-area">
              <div
                v-for="item in selectedCategories"
                :key="item.clsfCd"
                class="c-option-item"
              >
                <span class="text"
                  >{{ item.clsfNm }}(<span class="system">{{
                    item.productCount
                  }}</span
                  >)</span
                >
                <button
                  typee="button"
                  class="btn-delete"
                  @click="removeSelect(item)"
                >
                  <i class="c-icon icon-medium-x size-xxsmall"></i>
                  <span class="sr-only">삭제</span>
                </button>
              </div>
            </div>
          </div>
          <!-- // D: 필터 선택 -->

          <div class="c-btn-area">
            <button
              type="button"
              class="c-button type-secondary"
              @click="unsetAll"
            >
              <span>초기화</span>
            </button>
            <button
              type="button"
              class="c-button type-primary"
              @click="() => emits('categoriesSelected', searchCategories)"
            >
              <span> 제품찾기 </span>
            </button>
          </div>
        </div>
      </div>
      <!-- D: dimmed -->
      <div class="dimmed"></div>
    </template>
  </AbstractPop>
</template>
<script setup>

import { onMounted, defineEmits, computed, defineProps, ref, inject} from "vue";
import MobileFilterPopRow from "@/components/paintpro/prod/moFilterPopRow.vue";
import AbstractPop from "@/components/paintpro/common/AbstractPop.vue";
import { api } from "@/plugins/api";

const emits = defineEmits(["close", "categoriesSelected"]);
const url = inject("url_prefix");
const props = defineProps({
  searchCategories: {
    type: Object,
    required: true,
  },
  searchParams: {
    type: Object,
    required: true,
  }
});

const searchCategories = ref(
  JSON.parse(JSON.stringify(props.searchCategories))
);

const searchParams = ref(
  JSON.parse(JSON.stringify(props.searchParams))
);

onMounted(() => {});

const changeMoProd = async(gubn) => {

var strArray2 = Array();
[...searchCategories.value.lvl2Categories].filter((item) => item.selected === true).forEach(
(data) => strArray2.push(data.clsfCd)
);

var strArray3 = Array();
[...searchCategories.value.lvl3Categories].filter((item) => item.selected === true).forEach(
(data) => strArray3.push(data.clsfCd)
);

var strArray4 = Array();
[...searchCategories.value.lvl4Categories].filter((item) => item.selected === true).forEach(
(data) => strArray4.push(data.clsfCd)
);

const res = await api.post(`${url}/product/search-categories`, { keyword: searchParams.value.keyword.trim(), clsfCdListLvl2 : strArray2, clsfCdListLvl3 :strArray3 });
const { resultCode } = res;
if (resultCode !== 200) {return;}

if(gubn=='1'){
  searchCategories.value.lvl3Categories = res.data.lvl3Categories;
  
  for(var lvl3i=0; lvl3i<strArray3.length; lvl3i++){
    for(var lvl3ii=0; lvl3ii<searchCategories.value.lvl3Categories.length; lvl3ii++){
      if(strArray3[lvl3i] == searchCategories.value.lvl3Categories[lvl3ii].clsfCd){
        searchCategories.value.lvl3Categories[lvl3ii].selected = true;
      }
    }    
  }
}

searchCategories.value.lvl4Categories = res.data.lvl4Categories;

for(var lvl4i=0; lvl4i<strArray4.length; lvl4i++){
  for(var lvl4ii=0; lvl4ii<searchCategories.value.lvl4Categories.length; lvl4ii++){
    if(strArray4[lvl4i] == searchCategories.value.lvl4Categories[lvl4ii].clsfCd){
      searchCategories.value.lvl4Categories[lvl4ii].selected = true;
    }
  }    
}

window.dispatchEvent(new Event('resize'));
};

const lvl2Categories = computed(() => {
  if (!searchCategories.value) return [];

  return searchCategories.value.lvl2Categories;
});

const lvl3Categories = computed(() => {
  if (!searchCategories.value) return [];

  return searchCategories.value.lvl3Categories;
});

const lvl4Categories = computed(() => {
  if (!searchCategories.value) return [];

  return searchCategories.value.lvl4Categories;
});

// const totalQtyCategories = computed(() => {
//   if (!searchCategories.value) return [];

//   return searchCategories.value.totalQtyCategories;
// });

// const setgdYnCategories = computed(() => {
//   if (!searchCategories.value) return [];

//   return searchCategories.value.setgdYnCategories;
// });

const selectedCategories = computed(() => {
  if (!searchCategories.value) return [];

  return [
    ...searchCategories.value.lvl2Categories,
    ...searchCategories.value.lvl3Categories,
    ...searchCategories.value.lvl4Categories,
    ...searchCategories.value.totalQtyCategories,
    ...searchCategories.value.setgdYnCategories,
  ].filter((item) => item.selected === true);
});

const unsetAll = () => {
  [
    ...searchCategories.value.lvl2Categories,
    ...searchCategories.value.lvl3Categories,
    ...searchCategories.value.lvl4Categories,
    ...searchCategories.value.totalQtyCategories,
    ...searchCategories.value.setgdYnCategories,
  ].forEach((item) => (item.selected = false));
};

const removeSelect = (item) => {
  item.selected = false;
};
</script>
